export default "__VITE_ASSET__DLrJ1RuO__"